import {
  DefaultButton,
  FontSizes,
  IStackStyles,
  IStyleFunctionOrObject,
  ITheme,
  Link,
  Stack,
  styled,
} from '@fluentui/react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { alchemyThemeSelector } from '../../../web-legacy/packages/app/selectors/contactUsSelector';
import { StyledText } from '../../common/components/StyledText';
import { OsUpdateDeeplink } from '../../models/constants/getHelpConstants';
import { TagId } from '../../models/getHelp/GetHelpLoggingRequest';
import { getHelpLogger } from '../../utils/getHelpLogger';
import { resolveStyles } from '../../utils/resolveStyles';
import { getString } from '../../utils/stringLoader';
import { cherryHillButtonStyles } from '../styles/selfHelpStyles';
import { addGenevaLog } from '../../utils/statelessUtil';

export interface IOsUpdateCardStyleProps {
  theme: ITheme;
}

export interface IOsUpdateCardStyles {
  root: IStackStyles;
}

export interface IOsUpdateSupportCardProps {
  styles?: IStyleFunctionOrObject<IOsUpdateCardStyleProps, IOsUpdateCardStyles>;
  theme?: ITheme;
  correlationId: string;
}

const baseStyles = (props: IOsUpdateCardStyleProps): IOsUpdateCardStyles => ({
  root: {
    root: {
      background: props.theme.palette.neutralLight,
      marginBottom: '30px',
      padding: '16px',
      position: 'relative',
      borderRadius: '4px',
      lineHeight: '20px',
    },
  },
});

const OsUpdateCardBase = (props: IOsUpdateSupportCardProps): JSX.Element => {
  const [isVisible, setVisibility] = React.useState(true);

  const alchemyTheme = useSelector(alchemyThemeSelector);

  const styles = resolveStyles(
    {
      theme: props.theme,
    },
    props.styles
  );
  React.useEffect(() => {
    getHelpLogger.logGetCurrentEvent(TagId.GetCurrent_AfterSearch_NotificationDisplayed, alchemyTheme);
    addGenevaLog({
      eventName: 'GetCurrent_AfterSearch_NotificationDisplayed',
      correlationId: props.correlationId,
      alchemyTheme: alchemyTheme,
      behavior: 'DISPLAY',
    });
  }, []);

  if (!isVisible) {
    return null;
  }
  const onClickNotNowOnOsUpdateBar = () => {
    getHelpLogger.logGetCurrentEvent(TagId.GetCurrent_AfterSearch_NotNowLinkClicked, alchemyTheme);
    addGenevaLog({
      eventName: 'GetCurrent_AfterSearch_NotNowLinkClicked',
      correlationId: props.correlationId,
      alchemyTheme: alchemyTheme,
      behavior: 'CLICK',
    });
    setVisibility(false);
  };

  const onInstallUpdateButtonClick = () => {
    getHelpLogger.logGetCurrentEvent(TagId.GetCurrent_AfterSearch_InstallButtonClicked, alchemyTheme);
    addGenevaLog({
      eventName: 'GetCurrent_AfterSearch_InstallButtonClicked',
      correlationId: props.correlationId,
      alchemyTheme: alchemyTheme,
      behavior: 'CLICK',
    });
    // eslint-disable-next-line security/detect-non-literal-fs-filename
    window.open(OsUpdateDeeplink);
  };

  return (
    <Stack styles={styles.root} tokens={{ childrenGap: 13 }}>
      <StyledText>{getString('GetCurrentAfterSearchContent')}</StyledText>
      <Stack horizontal tokens={{ childrenGap: 20 }}>
        <DefaultButton
          styles={cherryHillButtonStyles}
          text={getString('GetCurrentButtonText')}
          onClick={onInstallUpdateButtonClick}
        />
        <Link styles={{ root: { fontSize: FontSizes.medium } }} onClick={onClickNotNowOnOsUpdateBar}>
          {getString('GetCurrentNotNowLink')}
        </Link>
      </Stack>
    </Stack>
  );
};
export const OsUpdateCard: React.FunctionComponent<IOsUpdateSupportCardProps> = styled(OsUpdateCardBase, baseStyles);
